// ELENCOS REAIS DO NBB.
//
// ⚠️ ARQUIVO GERADO. Não edite à mão: rode `node scripts/coletar-nbb.mjs`.
//
// Fonte: site oficial da LNB (lnb.com.br), coletado em 2026-09-04.
// Do site vêm NOME, NÚMERO, POSIÇÃO, ALTURA e IDADE -- todos verificáveis lá.
//
// ⚠️ `overall` e `potential` são ESTIMATIVAS. A LNB não publica avaliação de
// atleta, e não existe fonte pública para isso. A conta está em
// `estimarOverall`, no script, e usa idade, altura relativa à posição e a
// ordem no elenco. Quem conhece o NBB vai discordar de casos específicos --
// e para isso o número é fácil de corrigir: mexa no script, não aqui.

// 18 clubes, 270 atletas.
/** [nome, posicao, overall, potencial, idade] -- indexado pelo NOME do clube,
 *  que e como src/data/real-rosters.js procura o elenco. */
export const NBB_ROSTERS = {
  // 18 atletas
  "Flamengo": [
    ["Gui", 'ALA', 79, 79, 35],
    ["Cummings", 'AP', 76, 76, 37],
    ["V. Cauã", 'PIV', 78, 83, 22],
    ["Jhonatan", 'ALA', 76, 76, 38],
    ["Gueiros", 'ARM', 79, 84, 22],
    ["Baralle", 'ARM', 81, 83, 27],
    ["Daniel", 'ALA', 79, 84, 24],
    ["Yan", 'ARM', 75, 83, 20],
    ["Igor", 'ALA', 75, 83, 21],
    ["Manel", 'AP', 76, 81, 23],
    ["Otávio", 'ARM', 72, 80, 19],
    ["Lucas", 'PIV', 69, 77, 18],
    ["Doria", 'PIV', 76, 78, 28],
    ["Wesley", 'PIV', 77, 77, 31],
    ["Johnson Sr.", 'ALA', 72, 72, 35],
    ["Kayo", 'AP', 76, 78, 26],
    ["Negrete", 'ALA', 74, 76, 25],
    ["Alexey", 'ARM', 75, 75, 30],
  ],
  // 17 atletas
  "Franca": [
    ["Bennett", 'AA', 77, 77, 38],
    ["Megda", 'PIV', 74, 82, 17],
    ["Felício", 'PIV', 82, 82, 34],
    ["Nicolini", 'ARM', 76, 84, 19],
    ["Lucas Dias", 'AP', 85, 85, 31],
    ["Lucas", 'ARM', 75, 83, 19],
    ["Laterza", 'ARM', 81, 81, 29],
    ["Mineiro", 'AP', 77, 77, 38],
    ["Piá", 'AP', 76, 84, 21],
    ["Georginho", 'AA', 82, 82, 29],
    ["Rodriguez", 'ALA', 81, 83, 27],
    ["Vitor Hugo", 'PIV', 75, 83, 21],
    ["Kelwin", 'PIV', 71, 79, 18],
    ["Pedro", 'ALA', 70, 78, 20],
    ["David Jackson", 'ALA', 67, 67, 43],
    ["Vini", 'AA', 71, 79, 20],
    ["Zu Jr.", 'AA', 73, 78, 22],
  ],
  // 15 atletas
  "Minas": [
    ["Williams", 'ALA', 82, 82, 34],
    ["McCree", 'AP', 82, 82, 33],
    ["César", 'ALA', 79, 87, 21],
    ["Tonhão", 'AP', 74, 82, 20],
    ["Fischer", 'ARM', 78, 78, 35],
    ["Fuzaro", 'ALA', 80, 80, 31],
    ["Rodriguez", 'ARM', 73, 81, 18],
    ["Wini Silva", 'PIV', 75, 83, 21],
    ["Arengo", 'AA', 78, 78, 30],
    ["Kuehne", 'AA', 72, 80, 20],
    ["R. Rachel", 'AP', 79, 81, 26],
    ["Paranhos", 'PIV', 75, 75, 34],
    ["Yuri", 'ALA', 76, 81, 23],
    ["Vinci", 'PIV', 71, 79, 19],
    ["Frazier", 'ARM', 71, 71, 36],
  ],
  // 20 atletas
  "Paulistano": [
    ["Vitinho", 'ARM', 80, 85, 22],
    ["Pietro", 'ARM', 72, 80, 17],
    ["Luiz Guilherme", 'AA', 76, 84, 20],
    ["Rafael", 'ALA', 75, 83, 19],
    ["Bianchi", 'AA', 74, 82, 21],
    ["Avanso", 'AA', 70, 78, 19],
    ["Seixas", 'ARM', 79, 84, 22],
    ["Aragão", 'AP', 72, 80, 18],
    ["Leandro", 'PIV', 75, 80, 22],
    ["Gabriel", 'PIV', 73, 81, 20],
    ["Gabriel", 'ALA', 72, 80, 19],
    ["Henrique", 'AP', 71, 79, 20],
    ["Tovar", 'ARM', 74, 79, 22],
    ["Caio Mathias", 'ALA', 66, 74, 18],
    ["Landeira", 'ARM', 73, 81, 21],
    ["Siewert", 'PIV', 76, 76, 29],
    ["Gui Abreu", 'AP', 75, 77, 27],
    ["Neto", 'PIV', 69, 77, 21],
    ["Demétrio", 'PIV', 75, 75, 31],
    ["Hunter", 'AA', 74, 76, 28],
  ],
  // 11 atletas
  "Bauru": [
    ["Eugeniusz", 'AA', 81, 83, 25],
    ["Brite", 'ARM', 77, 77, 32],
    ["Gemerson", 'AP', 78, 78, 33],
    ["Gustavo", 'ALA', 75, 80, 22],
    ["Vithinho", 'ARM', 78, 78, 31],
    ["Pedro", 'ALA', 76, 78, 25],
    ["Aiub", 'ALA', 64, 72, 17],
    ["Mogi", 'ALA', 75, 75, 30],
    ["Augusto", 'AP', 74, 79, 23],
    ["Andrezão", 'PIV', 74, 79, 24],
    ["Materan", 'ALA', 74, 74, 30],
  ],
  // 21 atletas
  "Pinheiros": [
    ["Gregate", 'AA', 80, 85, 22],
    ["Sloan", 'ARM', 83, 85, 27],
    ["Pacheco", 'ARM', 79, 87, 21],
    ["Farabello", 'AA', 82, 84, 26],
    ["Dieger", 'AA', 77, 85, 19],
    ["Djalo", 'AP', 82, 84, 25],
    ["Meili", 'AA', 76, 84, 20],
    ["Boracina", 'ARM', 73, 81, 18],
    ["Buffat", 'ALA', 81, 83, 26],
    ["Nascimento", 'AA', 71, 79, 17],
    ["Penha Jr.", 'AP', 79, 81, 26],
    ["Thor", 'ALA', 71, 79, 17],
    ["Anthony", 'PIV', 74, 82, 20],
    ["Maciel", 'AP', 78, 83, 24],
    ["Brayan", 'AP', 75, 83, 20],
    ["João Marcelo", 'PIV', 71, 79, 18],
    ["Betinho", 'ALA', 72, 72, 37],
    ["Afonso", 'PIV', 74, 79, 22],
    ["Agapy", 'PIV', 73, 78, 22],
    ["Pastre", 'ALA', 70, 78, 19],
    ["M. Alessanco", 'ALA', 71, 79, 18],
  ],
  // 13 atletas
  "Corinthians": [
    ["Thomas", 'ALA', 83, 83, 30],
    ["Lukinhas", 'ALA', 80, 88, 21],
    ["T. Faria", 'ARM', 77, 82, 23],
    ["C. Borges", 'ALA', 75, 75, 35],
    ["Kaique", 'ALA', 75, 83, 21],
    ["M. Jamelão", 'ARM', 70, 78, 18],
    ["Victão", 'AP', 79, 79, 29],
    ["Raymundo", 'PIV', 73, 81, 21],
    ["Munford", 'ALA', 78, 80, 28],
    ["Clark", 'ALA', 76, 78, 28],
    ["Novaes", 'PIV', 76, 78, 25],
    ["Lucas Cauê", 'PIV', 76, 78, 28],
    ["Elinho", 'ARM', 72, 72, 37],
  ],
  // 16 atletas
  "Mogi": [
    ["Barry", 'ALA', 79, 84, 23],
    ["Gabriel Campos", 'ARM', 77, 82, 24],
    ["Ruivo", 'ARM', 80, 82, 28],
    ["Caldeira", 'ARM', 76, 81, 22],
    ["Vini Chagas", 'AP', 78, 83, 24],
    ["Anderson", 'ALA', 77, 79, 26],
    ["Pedroso", 'ALA', 70, 78, 19],
    ["Hinkle", 'ALA', 72, 72, 37],
    ["Duane Johnson", 'AA', 75, 75, 35],
    ["Paulo", 'AP', 73, 73, 32],
    ["Menca", 'AA', 73, 78, 24],
    ["Raul", 'ALA', 67, 75, 19],
    ["Bavoso", 'ARM', 66, 74, 18],
    ["Maicon Douglas", 'PIV', 73, 75, 25],
    ["Vitoriano", 'PIV', 65, 73, 19],
    ["Dikembe", 'PIV', 73, 75, 27],
  ],
  // 13 atletas
  "Brasilia": [
    ["Crescenzi", 'AA', 81, 81, 33],
    ["Davi", 'ARM', 77, 85, 19],
    ["Gustavo", 'ARM', 80, 85, 23],
    ["Corvalan", 'ARM', 82, 84, 27],
    ["Zago", 'ALA', 72, 80, 19],
    ["Pedro", 'ALA', 80, 80, 31],
    ["Lucas", 'ARM', 78, 78, 29],
    ["Brunão", 'PIV', 75, 80, 23],
    ["Paulichi", 'AP', 78, 80, 28],
    ["Buiú", 'AA', 76, 78, 25],
    ["Carbonari", 'PIV', 70, 70, 38],
    ["Von Haydin", 'ALA', 75, 77, 27],
    ["Beller", 'AP', 71, 76, 23],
  ],
  // 11 atletas
  "Caxias do Sul": [
    ["Augusto", 'ARM', 79, 81, 27],
    ["Vezaro", 'ALA', 75, 75, 33],
    ["Tiago M.", 'AA', 74, 79, 22],
    ["Omena", 'AA', 73, 78, 22],
    ["Rafa", 'PIV', 73, 73, 32],
    ["Humberto", 'ALA', 75, 75, 31],
    ["Miguel", 'ALA', 70, 75, 22],
    ["Tom", 'PIV', 71, 71, 33],
    ["Kopper", 'ALA', 68, 76, 21],
    ["Luan", 'PIV', 69, 74, 23],
    ["Fabrizzio", 'ARM', 70, 75, 24],
  ],
  // 14 atletas
  "Unifacisa": [
    ["Anthony", 'ARM', 76, 76, 33],
    ["Gerson", 'PIV', 77, 77, 34],
    ["Leal", 'PIV', 78, 78, 29],
    ["L. Marques", 'ALA', 66, 74, 17],
    ["Flores", 'AA', 74, 79, 22],
    ["Coelho", 'ARM', 75, 75, 33],
    ["Raviery", 'ARM', 72, 80, 21],
    ["Antônio", 'AP', 74, 74, 32],
    ["João Paulo", 'AP', 72, 77, 22],
    ["Jimmy", 'AA', 71, 71, 35],
    ["Vieira", 'AP', 63, 71, 17],
    ["Sifontes", 'AA', 74, 74, 31],
    ["Carr", 'ALA', 75, 75, 30],
    ["Melvin", 'ALA', 70, 70, 33],
  ],
  // 16 atletas
  "Pato Basquete": [
    ["Euler", 'ARM', 70, 75, 22],
    ["Naka", 'ARM', 69, 77, 20],
    ["Thompson", 'ARM', 74, 76, 26],
    ["Mateus", 'ALA', 69, 74, 23],
    ["Edu Marília", 'AP', 73, 75, 25],
    ["Lucas", 'ARM', 67, 75, 20],
    ["Crews", 'AA', 70, 75, 24],
    ["Nycolas", 'AP', 66, 71, 23],
    ["Gustavo", 'ALA', 67, 75, 21],
    ["N. Gomes", 'AP', 67, 72, 23],
    ["Grigor", 'AP', 65, 73, 20],
    ["Michel", 'ALA', 68, 68, 29],
    ["Willker Z.", 'PIV', 63, 71, 20],
    ["Fidelis", 'PIV', 67, 69, 25],
    ["D. Penteado", 'ALA', 67, 69, 26],
    ["Horton", 'ALA', 66, 71, 24],
  ],
  // 17 atletas
  "Sao Jose": [
    ["Dos Santos", 'AP', 81, 83, 28],
    ["Pedro", 'ALA', 76, 84, 21],
    ["Adyel", 'AA', 78, 83, 24],
    ["Jackson", 'AA', 73, 81, 20],
    ["Jojo", 'ARM', 72, 80, 19],
    ["Badu", 'AP', 71, 79, 19],
    ["Cauê", 'ARM', 73, 73, 38],
    ["Léo Cravero", 'AP', 76, 81, 24],
    ["João Guimarães", 'ARM', 72, 80, 19],
    ["Soto", 'ALA', 69, 77, 19],
    ["Nickel", 'ARM', 72, 80, 21],
    ["Pessoa", 'ALA', 71, 79, 21],
    ["Anderson", 'PIV', 75, 75, 29],
    ["Lessa", 'AA', 74, 74, 31],
    ["Miller", 'ALA', 70, 70, 35],
    ["Maique", 'PIV', 72, 72, 33],
    ["Isaque", 'PIV', 68, 76, 20],
  ],
  // 14 atletas
  "Botafogo": [
    ["NK", 'PIV', 70, 78, 20],
    ["Klebinho", 'ARM', 69, 77, 21],
    ["Machado", 'ARM', 72, 72, 35],
    ["Lucas", 'AA', 72, 77, 22],
    ["Jhonatan", 'PIV', 70, 78, 21],
    ["Matheusinho", 'ARM', 73, 75, 26],
    ["Lelê", 'ALA', 70, 72, 25],
    ["João Davi", 'ALA', 64, 72, 19],
    ["Paulino", 'ALA', 68, 76, 21],
    ["Emanuel", 'AP', 71, 73, 26],
    ["Derick", 'ALA', 71, 71, 29],
    ["Abner", 'PIV', 64, 64, 37],
    ["Scheuer", 'AP', 70, 72, 27],
    ["Machado Jr.", 'ALA', 71, 73, 28],
  ],
  // 13 atletas
  "Cruzeiro": [
    ["I. Thornton", 'ALA', 74, 74, 35],
    ["Nique Coleman", 'ALA', 72, 72, 38],
    ["Léo Abreu", 'ARM', 75, 80, 23],
    ["Bruninho", 'ARM', 72, 80, 21],
    ["Gittens", 'ARM', 76, 81, 24],
    ["Clay", 'AA', 73, 75, 26],
    ["Cassiano", 'AA', 74, 74, 29],
    ["JJ", 'ALA', 73, 75, 26],
    ["Ludwig", 'PIV', 72, 74, 25],
    ["Du Sommer", 'AP', 72, 72, 32],
    ["Sena", 'PIV', 72, 72, 30],
    ["Ansaloni", 'PIV', 64, 64, 39],
    ["Da Silva", 'AP', 70, 70, 30],
  ],
  // 12 atletas
  "Basquete Cearense": [
    ["Jeanzinho", 'ARM', 73, 75, 25],
    ["Augusto Vieira", 'ALA', 71, 76, 23],
    ["Janderson", 'ARM', 66, 74, 19],
    ["Da Silva", 'ALA', 75, 77, 26],
    ["Salsamendi", 'ALA', 72, 72, 29],
    ["Dupree", 'ARM', 71, 71, 31],
    ["Jelliel", 'PIV', 65, 73, 20],
    ["Cauã", 'PIV', 66, 71, 22],
    ["Popovic", 'PIV', 69, 71, 27],
    ["Samuel", 'PIV', 67, 69, 25],
    ["Alberton", 'PIV', 68, 73, 24],
    ["Gabriel", 'ALA', 66, 66, 29],
  ],
  // 14 atletas
  "Osasco": [
    ["Harris", 'AA', 76, 78, 28],
    ["Leoni", 'ARM', 71, 76, 22],
    ["Caribaux", 'ARM', 69, 74, 23],
    ["Elvis", 'ALA', 69, 74, 23],
    ["Dalaqua", 'ARM', 72, 74, 26],
    ["Tarek", 'AP', 72, 74, 25],
    ["Grant", 'ALA', 71, 71, 33],
    ["Passos", 'PIV', 63, 63, 40],
    ["Júlio", 'ARM', 64, 72, 20],
    ["Manaus", 'ALA', 68, 73, 24],
    ["Breno", 'AP', 65, 70, 23],
    ["Weber", 'ALA', 67, 69, 26],
    ["Malachias", 'PIV', 68, 70, 27],
    ["Eddy", 'ALA', 60, 60, 39],
  ],
  // 15 atletas
  "Uniao Corinthians": [
    ["Coelho", 'AA', 77, 82, 23],
    ["Cárdenas", 'ALA', 81, 83, 28],
    ["Rossetto", 'ARM', 74, 74, 34],
    ["Isaac", 'ALA', 74, 74, 36],
    ["Veríssimo", 'ALA', 76, 78, 28],
    ["Renan", 'ALA', 72, 77, 22],
    ["Hollowell", 'AP', 76, 76, 32],
    ["Thierry", 'ARM', 73, 78, 22],
    ["Scott", 'PIV', 75, 75, 32],
    ["Hettsheimeir", 'PIV', 67, 67, 40],
    ["Brandão", 'AP', 72, 77, 23],
    ["Barnes", 'ARM', 68, 68, 36],
    ["Góes", 'AA', 67, 67, 39],
    ["Jonatan", 'ALA', 71, 73, 27],
    ["Silva", 'ALA', 70, 75, 23],
  ],
};
